import * as React from 'react';

export const CalendarIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Leading">
      <path
        id="Vector"
        opacity="0.4"
        d="M2.5 15C2.5 16.6667 3.33333 17.5 5 17.5H15C16.6667 17.5 17.5 16.6667 17.5 15V7.5H2.5V15Z"
        fill="black"
      />
      <path
        id="Vector_2"
        d="M15 3.75H13.9583V2.5C13.9583 2.155 13.6783 1.875 13.3333 1.875C12.9883 1.875 12.7083 2.155 12.7083 2.5V3.75H7.29167V2.5C7.29167 2.155 7.01167 1.875 6.66667 1.875C6.32167 1.875 6.04167 2.155 6.04167 2.5V3.75H5C3.33333 3.75 2.5 4.58333 2.5 6.25V7.5H17.5V6.25C17.5 4.58333 16.6667 3.75 15 3.75Z"
        fill="black"
      />
      <path
        id="Vector_3"
        d="M6.68335 11.6667C6.22335 11.6667 5.84575 11.2933 5.84575 10.8333C5.84575 10.3733 6.21501 10 6.67501 10H6.68335C7.14419 10 7.51669 10.3733 7.51669 10.8333C7.51669 11.2933 7.14335 11.6667 6.68335 11.6667ZM10.85 10.8333C10.85 10.3733 10.4775 10 10.0167 10H10.0083C9.54835 10 9.17908 10.3733 9.17908 10.8333C9.17908 11.2933 9.55669 11.6667 10.0167 11.6667C10.4767 11.6667 10.85 11.2933 10.85 10.8333ZM14.1834 10.8333C14.1834 10.3733 13.8109 10 13.35 10H13.3417C12.8817 10 12.5124 10.3733 12.5124 10.8333C12.5124 11.2933 12.89 11.6667 13.35 11.6667C13.81 11.6667 14.1834 11.2933 14.1834 10.8333ZM7.51669 14.1667C7.51669 13.7067 7.14419 13.3333 6.68335 13.3333H6.67501C6.21501 13.3333 5.84575 13.7067 5.84575 14.1667C5.84575 14.6267 6.22335 15 6.68335 15C7.14335 15 7.51669 14.6267 7.51669 14.1667ZM10.85 14.1667C10.85 13.7067 10.4775 13.3333 10.0167 13.3333H10.0083C9.54835 13.3333 9.17908 13.7067 9.17908 14.1667C9.17908 14.6267 9.55669 15 10.0167 15C10.4767 15 10.85 14.6267 10.85 14.1667ZM14.1834 14.1667C14.1834 13.7067 13.8109 13.3333 13.35 13.3333H13.3417C12.8817 13.3333 12.5124 13.7067 12.5124 14.1667C12.5124 14.6267 12.89 15 13.35 15C13.81 15 14.1834 14.6267 14.1834 14.1667Z"
        fill="black"
      />
    </g>
  </svg>
);
